import BaseModel from "@/lib/models/BaseModel";
import {defaultCurrency} from "@/lib/models/sumbols";

export default class User extends BaseModel {
    private _uid: string = "";
    private _email: string = "";
    private _phone: string = "";
    private _name: string = "";
    private _verified: boolean = false;
    private _currency: { [k: string]: string | number } = defaultCurrency;


    get uid(): string {
        return this._uid;
    }

    set uid(value: string) {
        this._uid = value;
    }

    get email(): string {
        return this._email;
    }

    set email(value: string) {
        this._email = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get verified(): boolean {
        return this._verified;
    }

    set verified(value: boolean) {
        this._verified = value;
    }

    get phone(): string {
        return this._phone;
    }

    set phone(value: string) {
        this._phone = value;
    }

    get currency(): { [p: string]: string | number } {
        return this._currency ? this._currency : defaultCurrency;
    }

    set currency(value: { [p: string]: string | number }) {
        this._currency = value;
    }
}
